import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const paymentMethodSelector = createFeatureSelector<IState>('paymentMethods');
export const getPaymentMethodsSelector = createSelector(paymentMethodSelector, (state: IState) => state); 
export const getPaymentMethodSelector = createSelector(paymentMethodSelector, (state: IState) => state.selectedItem); 

